// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { enforcementLevelDisplayStyles } from "@sc/Overrides/Widgets/Budget/EnforcementLevelDisplay";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

enforcementLevelDisplayStyles.wrapper = {
    css: css`
        display: flex;
        gap: 5px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
        align-items: center;
    `,
};

enforcementLevelDisplayStyles.labelText = {
    as: "h3",
    variant: "h6",
    css: css`
        display: inline-block;
        margin-bottom: 0;
    `,
};
